import { render, staticRenderFns } from "./taxmodal.vue?vue&type=template&id=4807a7fd"
import script from "./taxmodal.vue?vue&type=script&lang=js"
export * from "./taxmodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports